import debounce from 'lodash.debounce';
import BaseModule from '../../../javascripts/helpers/baseModule';
import showElement from '../../../javascripts/dom/showElement';
import hideElement from '../../../javascripts/dom/hideElement';

export default class Menubar extends BaseModule {
  constructor(element) {
    super(element, 'menubar', [
      {
        selector: 'label',
        id: 'label'
      },
      {
        selector: 'dropdown-list',
        id: 'dropdownList'
      }
    ]);

    this.width = 0;
  }

  onResize() {
    const newWidth = this.elements.self.scrollWidth;

    if (newWidth !== this.width) {
      this.calculateInnerWidth();
    }

    this.width = newWidth;
  }

  /**
   * set menubar width to widest option
   * @returns {void}
   */
  calculateInnerWidth() {
    // reset width
    this.elements.label.style.width = '';

    const list = this.elements.dropdownList;

    list.style.opacity = 0;
    list.style.display = 'block';

    const labelWidth = this.elements.label.scrollWidth + 2;
    const listWidth = this.elements.dropdownList.scrollWidth;

    list.style.display = '';
    list.style.opacity = '';

    // dont set width is label is wider
    if (labelWidth >= listWidth) return;

    // add width to label adding extra pixel for scrollbars
    this.elements.label.style.width = `${listWidth + 30}px`;
  }

  toggleMenubar() {
    if (this.elements.label.getAttribute('aria-expanded') === 'true') {
      this.elements.label.setAttribute('aria-expanded', 'false');
      hideElement(this.elements.dropdownList);
    } else {
      this.elements.label.setAttribute('aria-expanded', 'true');
      showElement(this.elements.dropdownList);
    }
  }

  init() {
    this.elements.label.addEventListener('click', this.toggleMenubar.bind(this));
    this.elements.label.addEventListener('keydown', (e) => e.key === 'Enter' && this.toggleMenubar.bind(this));

    if (this.elements.self.dataset.calculateWidth) {
      // Resize eventlistener
      window.addEventListener(
        'resize',
        debounce((e) => {
          this.onResize();
        }, 100)
      );

      this.onResize();
    }
  }
}
